import styled from 'styled-components';

import { spaceMixin, token } from '@zillow/constellation';

export const StyledDetailsComponent = styled.div<{ marginBottomSize?: string | number }>`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  min-height: 74px;
  margin-bottom: ${({ marginBottomSize }) =>
    marginBottomSize !== undefined ? spaceMixin(marginBottomSize) : spaceMixin('sm')};
`;

export const StyledItemContainer = styled.div`
  flex-grow: 1;
  margin: 0 ${spaceMixin('xs')};
  width: 0;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const StyledVerticalLine = styled.div`
  flex-grow: 0;

  width: 1px;
  height: 51px;
  background: ${token('colors.gray300')};
`;
